import React from 'react';

import { ORDER_BY, paymentStatus } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import DebitsTable from './DebitsTable';
import { ListContainer } from 'components';
import { Box, Typography } from '@mui/material';

const duePaymentsTableHeads = [
    { id: 'checkbox', isSortable: false, width: 5, label: '' },
    { id: ORDER_BY.lastName, isSortable: false, width: 17, label: texts.NOM },
    {
        id: ORDER_BY.completedTunnelAt,
        isSortable: false,
        width: 10,
        label: texts.DATE,
    },
    { id: 'fundType', isSortable: false, width: 7, label: texts.TYPE },
    { id: ORDER_BY.fundName, isSortable: false, width: 12, label: texts.FUND },
    { id: 'fluxType', isSortable: false, width: 10, label: texts.ORDER_NUMBER },
    { id: ORDER_BY.investmentSum, isSortable: false, width: 13, label: texts.MONTANT_SOUSCRIT },
    { id: 'firstInstalmentAmount', isSortable: false, width: 10, label: texts.MONTANT_PRELEVEMENT },
    { id: 'debitDate', isSortable: false, width: 16, label: texts.FIRST_DEBIT_DATE },
];

const pendingPaymentsTableHeads = [
    { id: ORDER_BY.lastName, isSortable: false, width: 15, label: texts.NOM },
    {
        id: ORDER_BY.completedTunnelAt,
        isSortable: false,
        width: 10,
        label: texts.DATE,
    },
    { id: 'fundType', isSortable: false, width: 10, label: texts.TYPE },
    { id: ORDER_BY.fundName, isSortable: false, width: 12, label: texts.FUND },
    { id: 'fluxType', isSortable: false, width: 8, label: texts.ORDER_NUMBER },
    { id: ORDER_BY.investmentSum, isSortable: false, width: 13, label: texts.MONTANT_SOUSCRIT },
    { id: 'firstInstalmentAmount', isSortable: false, width: 11, label: texts.MONTANT_PRELEVEMENT },
    {
        id: 'paymentExecutionDate',
        isSortable: false,
        width: 16,
        label: texts.PAYMENT_EXECUTION_DATE,
    },
    { id: 'actions', isSortable: false, width: 5, label: '' },
];

const completedPaymentsTableHeads = [
    { id: ORDER_BY.lastName, isSortable: false, width: 14, label: texts.NOM },
    {
        id: ORDER_BY.completedTunnelAt,
        isSortable: false,
        width: 10,
        label: texts.DATE,
    },
    { id: 'fundType', isSortable: false, width: 10, label: texts.TYPE },
    { id: ORDER_BY.fundName, isSortable: false, width: 12, label: texts.FUND },
    { id: 'fluxType', isSortable: false, width: 8, label: texts.ORDER_NUMBER },
    { id: ORDER_BY.investmentSum, isSortable: false, width: 13, label: texts.MONTANT_SOUSCRIT },
    { id: 'firstInstalmentAmount', isSortable: false, width: 10, label: texts.MONTANT_PRELEVEMENT },
    {
        id: 'paymentExecutionDate',
        isSortable: false,
        width: 10,
        label: texts.PAYMENT_EXECUTION_DATE,
    },
    { id: 'settler', isSortable: false, width: 13, label: texts.SETTLED_BY },
    { id: 'actions', isSortable: false, width: 5, label: '' },
];

const DirectDebitToFunds = () => {
    return (
        <ListContainer>
            <Box marginBottom="20px">
                <Typography variant="h5" align="left" gutterBottom>
                    {texts.DIRECT_DEBIT_TO_FUNDS}
                </Typography>
            </Box>
            <DebitsTable
                title={texts.IN_PROCESS_DEBITS}
                listStatus={paymentStatus.CREATED}
                tableHeads={duePaymentsTableHeads}
                totalRowProps={{
                    labels: [texts.FUTURE_PAYMENTS_TOTAL, texts.EXECUTABLE_PAYMENTS_TOTAL],
                    firstColspan: 7,
                    maxColspan: 9,
                }}
            />
            <DebitsTable
                title={texts.PENDING_DEBITS}
                listStatus={paymentStatus.PENDING_CONFIRMATION}
                tableHeads={pendingPaymentsTableHeads}
                totalRowProps={{
                    labels: [texts.PAYMENTS_TOTAL],
                    firstColspan: 6,
                    maxColspan: 8,
                }}
            />
            <DebitsTable
                title={texts.DEBITS_HISTORY}
                listStatus={paymentStatus.CONFIRMED}
                tableHeads={completedPaymentsTableHeads}
            />
        </ListContainer>
    );
};

export default DirectDebitToFunds;
